<template>
  <div class="tw-relative tw-w-64 md:tw-w-40 xl:tw-w-64 tw-h-16">
    <div
      class="tw-absolute tw-right-0 tw-top-1/2 tw-transform tw--translate-y-1/2 search-box"
      :class="{
        'tw-w-96 tw-z-10 tw-transition-all tw-duration-300 tw-ease-in-out ':
          isBlur,
      }"
    >
      <!-- <b-form-input
        ref="searchInput"
        maxlength="20"
        class="tw-w-full tw-h-8"
        v-model="searchValue"
        type="text"
        autocomplete="off"
        size="sm"
        :placeholder="$t('请输入')"
        @focus="handleFocus"
        @input="isBlur = true"
        @change="handleSearch"
        @blur="handleBlur"
      ></b-form-input> -->
      <div
        class="input-box tw-relative tw-flex tw-items-center tw-px-3 tw-py-1 tw-border tw-border-gray-300 tw-rounded-full tw-bg-white"
        :class="{ 'search-input': isBlur }"
        style="width: 100%"
      >
        <b-icon
          icon="search"
          class="tw-text-gray-400 tw-w-3.5 tw-h-3.5 tw-cursor-pointer"
        ></b-icon>
        <input
          ref="searchInput"
          maxlength="20"
          class="tw-w-full tw-h-5 tw-ml-2"
          v-model="searchValue"
          type="text"
          autocomplete="off"
          size="sm"
          @focus="handleFocus"
          @input="isBlur = true"
          @change="handleSearch"
          @blur="handleBlur"
          :placeholder="$t('请输入')"
          style="font-size: 14px"
        />
      </div>
      <div
        class="tw-absolute tw-rounded-lg tw-w-full tw-flex tw-flex-col tw-mt-1 tw-bg-white tw-p-2 tw-shadow"
        style="min-height: 70px"
        v-if="isBlur"
      >
        <div class="tw-flex tw-flex-col tw-mb-2">
          <div class="tw-flex tw-items-center tw-pb-3" style="color: #666">
            <span class="tw-text-sm">{{ $t("搜索历史") }}</span>
            <b-icon
              icon="trash"
              class="tw-w-3 tw-h-3 tw-ml-1 tw-cursor-pointer"
              @mousedown.stop="handleClearSearch"
            ></b-icon>
          </div>
          <div class="tw-flex tw-gap-2 tw-flex-wrap" style="color: #666">
            <div
              class="tw-w-full tw-flex tw-items-center tw-justify-center tw-py-1"
              v-if="searchValues.length <= 0"
            >
              <span class="tw-text-sm">{{ $t("暂无搜索历史") }}</span>
            </div>
            <div
              v-for="item in searchValues"
              :key="item"
              class="search-item tw-text-sm tw-flex tw-items-center tw-justify-between tw-px-2 tw-rounded tw-py-0.5 tw-cursor-pointer"
              style="border: 1px solid #ebebeb"
              @mousedown.stop="handleHisSearch(item)"
            >
              <span>{{ item }}</span>
            </div>
          </div>
          <div
            class="tw-flex tw-items-center tw-pb-3 tw-mt-3"
            style="color: #666"
          >
            <span class="tw-text-sm" style="color: #409eff">{{
              $t("热门搜索")
            }}</span>
          </div>
          <div class="tw-flex tw-gap-2 tw-flex-wrap" style="color: #666">
            <div
              v-for="item in hotSearch"
              :key="item.keyword"
              class="search-item tw-text-sm tw-flex tw-items-center tw-justify-between tw-px-2 tw-py-0.5 tw-rounded tw-cursor-pointer"
              style="border: 1px solid #ebebeb"
              @mousedown.stop="handleHisSearch(item.keyword)"
            >
              <span>{{ item.keyword }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { hotSearchApi } from "@/api/modules/home";

export default {
  name: "TopSearch",
  data() {
    return {
      searchValue: "",
      isBlur: false,
      searchValues: [],
      hotSearch: [],
    };
  },
  mounted() {
    this.getHotSearch();
  },
  methods: {
    handleHisSearch(value) {
      this.$emit("onSearch", value);
      this.searchValue = value;
      this.handleFilterSearch();
    },
    handleFilterSearch() {
      for (let i = 0; i < this.searchValues.length; i++) {
        if (this.searchValues[i] == this.searchValue) {
          this.searchValues.splice(i, 1);
          break;
        }
      }
      this.searchValues.unshift(this.searchValue);
      if (this.searchValues.length > 10) {
        this.searchValues.pop();
      }
      localStorage.setItem("searchValues", JSON.stringify(this.searchValues));
      this.$emit("onSearch", this.searchValue);
      this.searchValue = "";
    },
    handleSearch(value) {
      this.$refs.searchInput.blur();
      this.isBlur = false;
      if (this.searchValue) {
        this.handleFilterSearch();
      }
    },
    getSearchValues() {
      this.searchValues =
        JSON.parse(localStorage.getItem("searchValues")) || [] || [];
    },
    getHotSearch() {
      hotSearchApi().then((res) => {
        this.hotSearch = res.data;
      });
    },
    handleFocus() {
      this.getSearchValues();
      this.isBlur = true;
    },
    handleBlur(blur) {
      console.log("blur==", blur);
      this.isBlur = false;
    },
    handleClearSearch() {
      this.searchValues = [];
      localStorage.removeItem("searchValues");
    },
  },
};
</script>
<style lang="scss" scoped>
.search-item:hover {
  color: #409eff;
}

.search-box {
  ::v-deep .form-control:hover {
    border-color: #409eff;
  }
}
.search-input {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgb(0, 123, 255, 0.25);
}
.input-box:hover {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgb(0, 123, 255, 0.25);
}
</style>
